import React, { Component } from "react";
import { Card, Form, Button, Alert } from "react-bootstrap";
import { Redirect } from 'react-router-dom'
import axios from "axios";
import CommonLoader from "./loaderComponent/CommonLoader";
import { validateDepartmentForm } from "../utils/validation";
import CommonToast from "./Toaster/CommonToast";
import { hasPermission } from "../utils/usePermission";

export default class DepartmentAdd extends Component {
  constructor(props) {
    super(props);

    this.state = {
      departmentName: "",
      hasError: false,
      errMsg: "",
      completed: false,
      loading: false,
      errors: {},
      showToast: false,
      toastMessage: '',
      toastVariant: '',
      color: ''
    };
  }



  handleChange = (event) => {
    const { value, name } = event.target;
    let errors = { ...this.state.errors };
    if (name === "departmentName" && value.trim()) {
      delete errors.departmentName;
    }
    this.setState({
      [name]: value,
      errors
    });
  };




  onSubmit = (e) => {
    this.setState({ loading: true })
    e.preventDefault()
    this.setState({ hasError: false, errorMsg: "", completed: false });
    const errors = validateDepartmentForm(this.state.departmentName);
    if (Object.keys(errors).length > 0) {
      this.setState({ errors, loading: false });
      return;
    }
    let department = {
      departmentName: this.state.departmentName
    };
    axios({
      method: "post",
      url: "/departments",
      data: department,
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    })
      .then((res) => {
        this.setState({
          completed: true,
          toastMessage: "Department created successfully!",
          toastVariant: 'success',
          color: 'green',
          showToast: true,
        })
        setTimeout(() => {
          this.setState({ loading: false, showToast: false });
        }, 900);
      })
      .catch((err) => {
        this.setState({
          hasError: true,
          errMsg: err.response.data.message,
          toastMessage: err.response.data.message,
          toastVariant: 'danger',
          color: 'red',
          showToast: true,
        });
        setTimeout(() => {
          this.setState({ showToast: false, loading: false });
        }, 900);

        window.scrollTo(0, 0);
      });
  };
  render() {
    return (
      <>
        {this.state.showToast && this.state.toastMessage && (
          <CommonToast
            show={this.state.showToast}
            onClose={() => this.setState({ showToast: false })}
            message={this.state.toastMessage}
            variant={this.state.toastVariant}
            color={this.state.color}
          />
        )}
        <CommonLoader isLoading={this.state.loading}>
          <Card className="">

            <Card.Header>
              <div className="panel-title">
                <strong>Department List</strong>
              </div>
            </Card.Header>
            <Card.Body>
              <>
                <Form onSubmit={this.onSubmit}>
                  <Form.Group controlId="formDepartmentName">
                    <Form.Label className="text-muted required mb-2">
                      Department Name
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter department name"
                      name="departmentName"
                      style={{ width: "50%" }}
                      value={this.state.departmentName}
                      onChange={this.handleChange}

                    />
                  </Form.Group>
                  <span className="login-error">
                    {this.state.errors.departmentName && <small className="text-danger">{this.state.errors.departmentName}</small>}
                  </span>
                  {hasPermission('M3B1') && (
                    <Button variant='primary' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button btn btn-primary" type="submit">
                      Add
                    </Button>
                  )}

                </Form>
              </>
            </Card.Body>
            {this.state.hasError ? (
              <Alert variant="outline-danger" className="m-3" block>
                {this.state.errMsg}
              </Alert>
            ) : this.state.completed ? (
              <Redirect to="/departments" />
            ) : (<></>)}
          </Card>
        </CommonLoader>
      </>
    );
  }
}
